import { Component, Input, Output, EventEmitter } from '@angular/core';
import { AuthService } from 'src/app/service/auth.service';

@Component({
  selector: 'app-event-sorting-toggle',
  templateUrl: './event-sorting-toggle.component.html',
})
export class EventSortingToggleComponent {
  @Input() sortByOptions: {
    value: string;
    icon: string;
    label?: string;
    tooltip?: string;
    class?: string;
  }[] = [];
  @Input() sortBy: string;
  @Input() hideTooltip: boolean = true; // Default value
  @Output() sortByChange = new EventEmitter<string>();

  customScore: string;

  constructor(public auth: AuthService) {
    this.customScore = this.auth.scorelabSettings.defaultScore;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onSortByChange(event: any) {
    this.sortByChange.emit(event.value);
  }
}
